import { AfterViewInit, Component, ElementRef, EventEmitter, forwardRef, Input, OnInit, Output, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AbstractControl, ControlValueAccessor, FormsModule, NG_VALIDATORS, NG_VALUE_ACCESSOR, Validator } from '@angular/forms';
import { UtilsModule } from '@shared/utils/utils.module';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-editor',
  templateUrl: './editor.component.html',
  styleUrls: ['./editor.component.css'],
  standalone: true,
  imports: [FormsModule, UtilsModule, CommonModule],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => EditorComponent),
      multi: true
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => EditorComponent),
      multi: true
    }
  ]
})
export class EditorComponent implements AfterViewInit, ControlValueAccessor, Validator {

  @Input() config: any;
  @Input() required = false;

  @Output() blur = new EventEmitter<Event>();
  @Output() ready = new EventEmitter<any>();
  @Output() ngModelChange = new EventEmitter<string>();

  @ViewChild('editorContainer') editorContainer!: ElementRef;

  private editorInstance: any;
  private innerValue = '';
  private onChange = (_: any) => { };
  private onTouched = () => { };

  ngAfterViewInit(): void {
    const ClassicEditor = (window as any).ClassicEditor;
    this.setConfig();
    ClassicEditor
      .create(this.editorContainer.nativeElement, this.config || {})
      .then((editor: any) => {
        this.editorInstance = editor;
        editor.setData(this.innerValue);

        editor.model.document.on('change:data', () => {
          const data = editor.getData();
          this.innerValue = data;
          this.onChange(data);
          this.ngModelChange.emit(data);
        });

        editor.ui.view.editable.element.addEventListener('blur', (e: Event) => {
          this.onTouched();
          this.blur.emit(e);
        });

        this.ready.emit(editor);
      });
  }

  setConfig(): void {
    let defaultConfig: any = {
      licenseKey: environment.ckEditorLicenceKey
    };

    this.config = Object.assign(defaultConfig, this.config ?? {});
  }

  writeValue(value: any): void {
    this.innerValue = value ?? '';
    if (this.editorInstance) {
      this.editorInstance.setData(this.innerValue);
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  validate(control: AbstractControl): any {
    return this.required && !this.innerValue ? { required: true } : null;
  }

}
